import services from '@/http';
import { user } from '@/http';

export const ActionSendEmailOrSmsText = (_, payload) => {
    user.sendSmsOrEmail.data = payload;

    return services.http.request(user.sendSmsOrEmail)
        .then(response => {
            return response;
        })
        .catch((err) => {
            return err;
        });
}

export const ActionGetDebtsPortoSeguro = (_, payload) => {
    user.getDebtsPortoSeguro.data = payload;
    return services.http.request(user.getDebtsPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionEmitirFaturaPortoSeguro = (_, payload) => {
    user.emitirFaturaPortoSeguro.data = payload;
    return services.http.request(user.emitirFaturaPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionBoletoPortoSeguro = (_, payload) => {
    user.boletoPortoSeguro.data = payload;
    return services.http.request(user.boletoPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
          throw e
        })
}

export const ActionBoletosLinhaDigitavelPortoSeguro = (_, payload) => {
    user.boletosLinhaDigitavelPortoSeguro.data = payload;
    return services.http.request(user.boletosLinhaDigitavelPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
           throw e;
        })
}

export const ActionBoletoInfoPortoSeguro = (_, payload) => {
    user.boletoInfoPortoSeguro.data = payload;
    return services.http.request(user.boletoInfoPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
           throw e;
        })
}

export const ActionPixPortoSeguro = (_, payload) => {
    user.pixPortoSeguro.data = payload;
    return services.http.request(user.pixPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
           throw e;
        })
}

export const ActionGetOffersPortoSeguro = (_, payload) => {
    user.getOffersPortoSeguro.data = payload;
    return services.http.request(user.getOffersPortoSeguro)
        .then(response => {
            // console.log('1231231: ' + JSON.stringify(response));
            return response;

        }).catch((e) => {
            throw e;
        })
}

export const ActionGetOffersFaturaPortoSeguro = (_, payload) => {
    user.getOffersFaturaPortoSeguro.data = payload;
    return services.http.request(user.getOffersFaturaPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e
        })
}

export const ActionGetAgreementPortoSeguro = (_, payload) => {
    user.agreementPortoSeguro.data = payload;
    return services.http.request(user.agreementPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}

export const ActionContatoWhatsapp = ( _, payload) => {
    user.contatoWhatsapp.data = payload;
    return services.http.request(user.contatoWhatsapp)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}

export const ActionSendMessagePortoSeguro = (_, payload) => {
    user.sendMessagePortoSeguro.data = payload;
    return services.http.request(user.sendMessagePortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}

export const ActionHistoryMessagesPortoSeguro = (_, payload) => {
    user.historyMessagesPortoSeguro.data = payload;
    return services.http.request(user.historyMessagesPortoSeguro)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}

export const ActionClickAvatar = ( _, payload) => {
    user.clickAvatar.data = payload;
    return services.http.request(user.clickAvatar)
        .then(response => {
            return response.data.results;
        }).catch((e) => {
            throw e;
        })
}